import styled from 'styled-components';
import { FONT_FAMILY, MQS, SHADOWS, SPACINGS, COLORS } from '../../app/common/constants/styles';

export const Base = styled.div`
    background-color: #fff;
    border-radius: 4px;
    box-shadow: ${SHADOWS.level1};
    padding: ${SPACINGS.base * 1.25}px ${SPACINGS.base * 6.25}px;
    padding-bottom: 40px;

    @media (max-width: ${MQS.mq2Min}) {
        padding: ${SPACINGS.base * 1.25}px ${SPACINGS.base * 3.25}px;
    }
`;

export const ServiceWrapper = styled.div`
    margin-bottom: 32px;
`;

export const Header = styled.div`
    ${FONT_FAMILY.multipleBoldCss};
    font-size: 1.75rem;
    margin: 18px auto 26px 0;
`;

export const Description = styled.div`
    font-size: 12px;
    ${FONT_FAMILY.multipleRegularCss};
    font-weight: 400;
    margin-bottom: 24px;
`;

export const Info = styled(Description)`
    color: ${COLORS.grey7};
    margin: 0;
`;

export const InfoList = styled.ul`
    padding: 20px 0 0 16px;
    margin: 0;
`;

export const ServiceLinkListWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: left;

    @media (max-width: ${MQS.mq2Min}) {
        justify-content: center;
    }
`;

export const ServiceLinkWrapper = styled.div`
    margin: 8px 0;
    padding-right: 16px;
    flex-basis: 50%;
    @media (max-width: ${MQS.mq2Min}) {
        flex-basis: 100%;
    }
`;

export const Link = styled.a`
    transition: color 100ms ease-in;
    text-decoration: underline;
    color: ${COLORS.grey7};
    cursor: pointer;
    &:hover {
        color: ${COLORS.dark2};
    }
`;

export const Spacer = styled.div`
    margin-top: 16px;
`;
